import type { Token } from "@/domains/core"

import { useChainConfig } from "./use-chain-config"

export const useVestedToken = () => {
  const chainConfig = useChainConfig()

  return chainConfig.tokens.vested as Token
}
